import _ from 'lodash';

export default class BaseAddModal {

    constructor ($uibModalInstance, store, UserService) {
        "ngInject";

        this.data = {};
        this.store = store;
        this.$modal = $uibModalInstance;

        if (UserService.$user.companies.length > 0) {
            this.data.company = _.first(UserService.$user.companies);
            if (UserService.$user.default_company) {
                this.data.company = UserService.$user.companies.find(
                    (x) => x.id === UserService.$user.default_company
                )
            }
        }
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        this.store.create(this.data)
            .then(
                (data) => this.$modal.close(data),
                (response) => { self.errors = response.data; },
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/create.modal.js